import { z } from "zod"

export function nonNullable<T>(value: T): value is NonNullable<T> {
  return value !== null && value !== undefined
}

/**
 * Type guard that checks whether a value is a finite number greater than zero.
 *
 * @param value Number-like value to validate.
 * @returns `true` when `value` is a positive finite number.
 */
export const isPositiveFiniteNumber = (
  value: number | null | undefined,
): value is number =>
  typeof value === "number" && Number.isFinite(value) && value > 0

// TODO: implement validation according to international standard E.164 used by Shopify
// https://en.wikipedia.org/wiki/E.164
export function isValidPhone(phone: string | null | undefined): boolean {
  return Boolean(phone)
}

export function isValidEmail(email: string | null | undefined): boolean {
  if (typeof email !== "string") {
    return false
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

const uuidSchema = z.uuid()

/**
 * Checks whether a string is a valid UUID (RFC 9562/4122).
 */
export function isValidUUID(str: string | null | undefined): boolean {
  return uuidSchema.safeParse(str).success
}

export function isValidUrl(url: string | null | undefined): boolean {
  if (typeof url !== "string" || !url.trim()) {
    return false
  }
  try {
    new URL(url)
    return true
  } catch {
    return false
  }
}

export function formatZipCode({
  zipCode,
  countryCode,
}: {
  zipCode: string
  countryCode: string
}): string {
  if (countryCode === "LV") {
    const match = zipCode.match(/\d{4}/)
    if (match && match[0]) {
      return match[0]
    }
  }
  if (countryCode === "PL") {
    return zipCode.replace("-", " ")
  }
  return zipCode
}
